import { CustomerService } from '.'

class CustomerOrderService {
  private customerService: CustomerService

  constructor(customerService: CustomerService) {
    this.customerService = customerService
  }

  list() {
    const { id } = this.customerService.getCustomer()
    const url = `/customers/${id}/orders`
    const req = this.customerService.setUrl(url).get()
    return req
  }
}

export default CustomerOrderService
